// extracted by mini-css-extract-plugin
export default {"gridContainer":"OrgStructureGrid_gridContainer__1noo6"};